/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Card_Upgrade_PlanInputs */

const en_settings_billing_card_upgrade_plan = /** @type {(inputs: Settings_Billing_Card_Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade plan`)
};

const es_settings_billing_card_upgrade_plan = /** @type {(inputs: Settings_Billing_Card_Upgrade_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar plan`)
};

/**
* | output |
* | --- |
* | "Upgrade plan" |
*
* @param {Settings_Billing_Card_Upgrade_PlanInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_billing_card_upgrade_plan = /** @type {((inputs?: Settings_Billing_Card_Upgrade_PlanInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Card_Upgrade_PlanInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_card_upgrade_plan(inputs)
	return es_settings_billing_card_upgrade_plan(inputs)
});